import { useState, useEffect } from 'react';

// Data alvo: 17/03/2026 às 19h30 no horário de Mato Grosso (UTC-4)
// Em UTC: 17/03/2026 23:30:00
const EVENT_DATE = new Date('2026-03-17T23:30:00Z');

function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });

  useEffect(() => {
    const calc = () => {
      const now = new Date();
      const diff = EVENT_DATE.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setTimeLeft({
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      });
    };
    calc();
    const interval = setInterval(calc, 1000);
    return () => clearInterval(interval);
  }, []);

  return timeLeft;
}

export default function CountdownCard() {
  const { days, hours, minutes, seconds } = useCountdown();

  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-8 sm:py-12 bg-gray-950 lg:hidden">
      <div className="max-w-lg mx-auto px-4">
        <div className="bg-black/80 border border-yellow-500/30 rounded-2xl px-4 sm:px-8 py-6 sm:py-8">
          <div className="mb-5">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="text-red-500 text-base animate-pulse">🔴</span>
              <p className="text-white font-black text-sm sm:text-base">
                Vagas restantes: <span className="text-red-400 text-lg sm:text-2xl">23</span>
              </p>
            </div>
            <div className="flex justify-center gap-1 mb-2 overflow-hidden">
              {Array.from({ length: 30 }).map((_, i) => (
                <div
                  key={i}
                  className={`w-1.5 sm:w-2 h-4 sm:h-5 rounded-sm transition-all duration-700 ${i < 7 ? 'bg-green-500' : 'bg-white/10'}`}
                />
              ))}
            </div>
            <p className="text-gray-400 text-xs text-center">
              <span className="text-red-400 font-bold">23</span> de 30 vagas disponíveis
            </p>
          </div>

          <div className="flex items-center gap-3 mb-4 max-w-xs mx-auto">
            <div className="flex-1 h-px bg-yellow-500/20"></div>
            <i className="ri-time-fill text-yellow-500/60 text-sm"></i>
            <div className="flex-1 h-px bg-yellow-500/20"></div>
          </div>

          <div className="flex items-center gap-2 mb-3 justify-center">
            <i className="ri-fire-fill text-red-400 text-base animate-pulse"></i>
            <p className="text-white font-black text-sm sm:text-base text-center">
              Restam apenas <span className="text-red-400 text-lg sm:text-xl">23</span> vagas para esta cidade.
            </p>
            <i className="ri-fire-fill text-red-400 text-base animate-pulse"></i>
          </div>

          <p className="text-gray-400 text-xs font-semibold tracking-widest uppercase text-center mb-4">
            O evento começa em
          </p>

          <div className="flex items-center justify-center gap-1.5 sm:gap-3">
            <TimeUnit value={days} label="Dias" />
            <Separator />
            <TimeUnit value={hours} label="Horas" />
            <Separator />
            <TimeUnit value={minutes} label="Min" />
            <Separator />
            <TimeUnit value={seconds} label="Seg" />
          </div>

          <button onClick={scrollToForm} className="w-full mt-6 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black py-3.5 rounded-full text-sm font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer">
            GARANTIR MINHA VAGA
          </button>
        </div>
      </div>
    </section>
  );
}

function TimeUnit({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col items-center">
      <div className="bg-black/60 border border-yellow-500/30 rounded-xl w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center">
        <span className="text-xl sm:text-2xl font-black text-yellow-400 tabular-nums">{value}</span>
      </div>
      <span className="text-gray-500 text-[10px] font-semibold mt-1.5 tracking-wider uppercase">{label}</span>
    </div>
  );
}

function Separator() {
  return <span className="text-yellow-500/60 text-xl font-black mb-4 select-none">:</span>;
}
